<template>
  <div>
    <span v-if="this.errors.size > 0">{{ this.errors[0] }}</span>

    <label for="show_name">Name</label>
    <input type="text" class="form-control" id="show_name" v-model="show.name">

    <label for="show_finished">Finished</label>
    <input type="text" class="form-control" id="show_finished" v-model="show.finished">

    <label for="show_video_quality">Video Quality</label>
    <input type="text" class="form-control" id="show_video_quality" v-model="show.video_quality">

    <label for="show_audio_quality">Audio Quality</label>
    <input type="text" class="form-control" id="show_audio_quality" v-model="show.audio_quality">

    <label for="show_subtitles">Subtitles</label>
    <input type="text" class="form-control" id="show_subtitles" v-model="show.subtitles">

    <label for="show_chapters">Chapters</label>
    <input type="text" class="form-control" id="show_chapters" v-model="show.chapters">

    <label for="show_titles">Titles</label>
    <input type="text" class="form-control" id="show_titles" v-model="show.titles">

    <label for="show_metadata">Metadata</label>
    <input type="text" class="form-control" id="show_metadata" v-model="show.metadata">

    <label for="show_embedded_images">Embedded Images</label>
    <input type="text" class="form-control" id="show_embedded_images" v-model="show.embedded_images">

    <label for="show_container">Container</label>
    <input type="text" class="form-control" id="show_container" v-model="show.container">

    <label for="show_video_format">Video Format</label>
    <input type="text" class="form-control" id="show_video_format" v-model="show.video_format">

    <label for="show_audio_format">Audio Format</label>
    <input type="text" class="form-control" id="show_audio_format" v-model="show.audio_format">

    <label for="show_source">Source</label>
    <input type="text" class="form-control" id="show_source" v-model="show.source">

    <label for="show_duration">Duration</label>
    <input type="text" class="form-control" id="show_duration" v-model="show.duration">

    <label for="show_size">Size</label>
    <input type="text" class="form-control" id="show_size" v-model="show.size">


    <button v-on:click="createShow" type="button" class="btn btn-success">Create Show</button>
  </div>
</template>

<script>

import { ShowService } from '@/common/services/show.service';

export default {
  name: 'ShowNew',
  components: {

  },
  data() {
    return {
      show: {
        name: '',
        finished: '',
        video_quality: '',
        audio_quality: '',
        subtitles: '',
        chapters: '',
        titles: '',
        metadata: '',
        embedded_images: '',
        container: '',
        video_format: '',
        audio_format: '',
        source: '',
        duration: '',
        size: '',
      },
      errors: [],
    };
  },
  created() {},
  methods: {
    createShow() {
      ShowService.create(this.show)
      .then(({ data }) => {
        this.$router.push({ name: 'ShowShow', params: { id: data.id } }, () => {
          // Derp
        });
      })
      .catch((err) => { console.warn(err.response.data); this.errors = err.response.data.error; });
    },
  },
};

</script>

<style lang="scss" scoped>

</style>
